import React from 'react';
/*
import jsPDF from 'jspdf';
import {
  hf,
  ht,
  cr,
  a,
  ls,
//  BarC,
  BoxC,
  BtnC,
  GridC,
  MsgC,
} from 'lib';
*/
import * as BoxC from "./_ccbBoxC";
import * as GridC from "./_cccGridC";
import * as BtnC from "./_cccBtnC";
import * as cr from './_cr';
import { a } from "./_csAbt";
import * as ls from "./_csLcl"; // local state
import * as _cv_10___Mz from "./_cv_10___Mz";
import * as _cv_31___Mz from "./_cv_31___Mz";
import * as _cv_40___Mz from "./_cv_40___Mz";
import * as _cv_60___Mz from "./_cv_60___Mz";
import * as ht from './_ht';

import * as icvI1z___EzP1 from './icvI1z___EzP1';

let $url: ht.s;

export const N = (pz: {
  sPz: ht.dz,
}) => {

  const _udtThis = ls.udtThis();

  React.useEffect(() => {
    //hf.l(`icvI1zS11Co4 23: ${pz.sPz.crt.i1zr_fst}`);
    icvI1z___EzP1.eptPdfAsync1({
      i1zr_fsts: [pz.sPz.crt.i1zr_fst]
    })
    .then((_url: ht.s|undefined) => {
      //hf.l(`icvI1zS11Co4 29: ${_url}`);
      $url = _url ?? '';
      _udtThis();
    });
  }, [
    pz.sPz.crt.i1zr_fst
  ]);

/*
  let _doc = new jsPDF()
  _doc.text("new pdf file", 10, 10);
  _doc.setProperties({
    title: '利用申請書',
  })
  const _url = URL.createObjectURL(_doc.output("blob"));
*/

/*
  const _dffz = icm.grtDffz({
    mode: pz.sPz.ctt,
  });
*/

  return (
    cr.c(BoxC.N, {
      key: -10,
      abtType: 'bdyCmnz',
      oClds: [

        cr.c(GridC.N, {
          key: -10,
          abtType: 'barFtnStfz',
          boxStlz: a('mb/2'),
        }),

        cr.c(BoxC.N, {
          key: -20,
          abtType: 'cttCmnz',
          oClds: [

/*
            cr.c(MsgC.N, {
              key: -10,
              abtType: 'ornCmnz',
              boxStlz: a('mb/2'),
              cz: {
                ls: [
                  {
                    msgCz: {
                      textz: {
                        pfx: '必要に応じ、利用申請書を出力・保存ください。',
                      }
                    }
                  },
                ]
              },
            }),
*/

            cr.c(BoxC.N, {
              key: -20,
              boxStlz: a('dw/f f/1'),
              oClds: [
                cr.c('iframe', {
                  key: -10,
//                  src: _url,
                  src: $url,
                  height: '100%',
                  width: '100%',
                }),
              ]
            }),

            cr.c(GridC.N, {
              key: -30,
              abtType: 'barBtnViewCmnz',
              lineCs: [
                {
                  cellCs: [
                    {
                      oClds: [

                        cr.c(BtnC.N, {
                          key: -10,
                          abtType: 'backCmnz',
                          lblCz: {
                            textz: {
                              pfx: '予約詳細画面に移動する'
                            }
                          },
                          pslPtyz: {
                            onPress: () => {
                              pz.sPz.set({
                                steps: [3],
                                phs: 'dpy',
                              })
                            }
                          },
                        }),
                      ]
                    },
                    {
                      oClds: [
                        cr.c(BtnC.N, {
                          key: -20,
                          abtType: 'backCmnz',
                          lblCz: {
                            textz: {
                              pfx: `${pz.sPz.crt.dffz.tgt}一覧画面に戻る`,
                            }
                          },
                          pslPtyz: {
                            onPress: () => {
                              pz.sPz.set({
                                steps: [0],
                              })
                            }
                          },
                        })
                      ]
                    }
                  ]
                }
              ]
            })
          ]
        }),




      ]
    })
  );
};
